<template>
    <router-view></router-view>
</template>

<script>
export default {
    name: "QrBase"
}
</script>

<style scoped>

</style>